(function ($) {
    $(document).ready(function () {

        var $window = $(window);
        var $slickSlider = $('.video-gallery .three-cards .wrapper');
        var settings = {
            speed: 300,
            dots: true,
            arrows: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            adaptiveHeight: false,
        };

        $('.video-gallery .three-cards .col-3').on("click", function () {
            var index = $(this).index();
            $(this).addClass('active').siblings().removeClass('active');
            $('.video-gallery .slide').eq(index).addClass('active').siblings().removeClass('active');
        });

        function initSlick() {
            if ($window.width() < 768) {
                if (!$slickSlider.hasClass('slick-initialized')) {
                    $slickSlider.slick(settings);
                }
            } else {
                if ($slickSlider.hasClass('slick-initialized')) {
                    $slickSlider.slick('unslick');
                }
            }
        }

        initSlick();
        
        $(window).on('resize', function () {
            initSlick();
        });

        // Update slide on dot click
        $(document).on('click', '.video-gallery .slick-dots li', function () {
            var index = $(this).index();
            $('.video-gallery .three-cards .col-3').eq(index).addClass('active').siblings().removeClass('active');
        });

        $slickSlider.on('afterChange', function (event, slick, currentSlide) {
            $('.video-gallery .slide').eq(currentSlide).addClass('active').siblings().removeClass('active');
        });

    });
})(jQuery);
